import React from "react";
import PropTypes from "prop-types";
import InternalMenuItem from "./InternalMenuItem";
import ExternalMenuItem from "./ExternalMenuItem";
import { ListItem } from './MenuStyle';

const MenuItem = ({ menu, drawerOpen, activeRoute }) => {
  const isExternal = menu.path.toLowerCase().indexOf("/external/") !== -1;
  return (
    <ListItem>
      {isExternal ? (
        <ExternalMenuItem menu={menu} drawerOpen={drawerOpen} activeRoute={activeRoute} />
      ) : (
        <InternalMenuItem menu={menu} drawerOpen={drawerOpen} activeRoute={activeRoute} />
      )}
    </ListItem>
  );
};

MenuItem.propTypes = {
  menu: PropTypes.object,
  drawerOpen: PropTypes.bool.isRequired,
  activeRoute: PropTypes.func.isRequired
};

export default MenuItem;
